import { createTheme } from "@mui/material/styles";

// Common typography settings
const typography = {
  fontFamily: [
    "Inter Variable",
    "SF Pro Display",
    "-apple-system",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    "Roboto",
    "Oxygen",
    "Ubuntu",
    "Cantarell",
    '"Open Sans"',
    '"Helvetica Neue"',
    '"Linear Thai"',
    "sans-serif",
  ].join(","),
  h1: {
    fontWeight: 700,
    fontSize: "2.5rem",
  },
  h2: {
    fontWeight: 500,
    fontSize: "1.5rem",
  },
  h3: {
    fontWeight: 600,
    fontSize: "1.75rem",
  },
  h4: {
    fontWeight: 600,
    fontSize: "1.5rem",
  },
  h5: {
    fontWeight: 500,
    fontSize: "1.25rem",
  },
  h6: {
    fontWeight: 500,
    fontSize: "1rem",
  },
  body1: {
    fontSize: "1rem",
  },
  body2: {
    fontSize: "0.875rem",
  },
  button: {
    textTransform: "none",
  },
  caption: {
    fontSize: "0.75rem",
  },
};

const MuiComponents = (palette) => ({
  MuiButton: {
    styleOverrides: {
      root: {
        boxShadow: "none",
        "&:hover": {
          boxShadow: "none",
        },
        "&:active": {
          boxShadow: "none",
        },
        "&:focus": {
          boxShadow: "none",
        },
      },
      contained: {
        "&.MuiButton-containedAction": {
          background: palette.text.primary,
        },
        color: palette.background.default,
      },
    },
  },
  MuiMenu: {
    styleOverrides: {
      paper: {
        backgroundColor: palette.background.default,
        color: palette.text.primary,
        boxShadow: `1px 1px 5px ${palette.borderColor.default}`,
        borderRadius: "8px",
        border: `1px solid ${palette.borderColor.dark}`,
        padding: "4px",
      },
      list: {
        padding: 0,
      },
    },
  },
  MuiMenuItem: {
    styleOverrides: {
      root: {
        paddingInline: "4px",
        "&:hover": {
          backgroundColor: palette.background.secondary,
          borderRadius: "8px",
        },
      },
    },
  },
  MuiDialog: {
    styleOverrides: {
      paperFullWidth: {
        backgroundImage: "none",
        border: `1px solid ${palette.borderColor.default}`,
        borderRadius: "8px",
      },
    },
  },
  MuiDialogContent: {
    styleOverrides: {
      root: {
        padding: "16px !important",
      },
    },
  },
  MuiDialogTitle: {
    styleOverrides: {
      root: {
        borderBottom: `1px solid ${palette.borderColor.default}`,
      },
    },
  },
});

const lightPalette = {
  mode: "light",
  primary: {
    main: "#1976d2",
  },
  secondary: {
    main: "#dc004e",
  },
  background: {
    default: "#ffffff",
    paper: "#ffffff",
    secondary: "#F9F9F9",
    dark: "#00000010",
  },
  borderColor: {
    light: "#00000005",
    default: "#0000000f",
    dark: "#0000001a",
  },
  white: {
    main: "#ffffff",
  },
  revert: "#000000",
  current: "#000000",
  text: {
    disabled: "rgba(0, 0, 0, 0.38)",
    primary: "rgba(0, 0, 0, 0.87)",
    secondary: "rgba(0, 0, 0, 0.6)",
  },
};

const darkPalette = {
  mode: "dark",
  primary: {
    main: "#1976d2",
  },
  secondary: {
    main: "#dc004e",
  },
  background: {
    default: "lch(4.8 0.7 272)",
    paper: "lch(10.633 1.867 272)",
    secondary: "lch(2.467% 0 272 / 1)",
    dark: "#ffffff10",
  },
  borderColor: {
    light: "#ffffff05",
    default: "#ffffff0f",
    dark: "#ffffff1a",
  },
  white: {
    main: "#ffffff",
  },
  revert: "#ffffff",
  current: "#000000",
  text: {
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)",
    primary: "#fff",
    secondary: "rgba(255, 255, 255, 0.7)",
  },
};

const shape = {
  borderRadius: "8px",
};

const lightTheme = createTheme({
  palette: lightPalette,
  typography: typography,
  components: MuiComponents(lightPalette),
  shape: shape,
});

const darkTheme = createTheme({
  palette: darkPalette,
  typography: typography,
  components: MuiComponents(darkPalette),
  shape: shape,
});

export { lightTheme, darkTheme };
